import React, { useState, useEffect } from 'react';
import { FaAngleUp } from 'react-icons/fa';
import './ScrollToTop.css';

function ScrollToTop() {
    const [showTopBtn, setShowTopBtn] = useState(false)

    useEffect(() => {
      window.addEventListener('scroll', () => {
        if(window.scrollY > 400) {
          setShowTopBtn(true)
        } else {
          setShowTopBtn(false)
        }
      });
    }, [])

    const goToTop = () => {
      window.scrollTo({
          top: 0,
          behavior: 'smooth',
      });
  };
   

  return (
    <div className='scroll_totop'>
      { showTopBtn && 
        <FaAngleUp  className='icon_angle_up icon_style' onClick={goToTop}/>
      }
       
    </div>
  )
}

export default ScrollToTop;